import { Base64 as Base64lib } from "js-base64";

/**
 * Wrapper around js-base64 library provides basic methods for Base64 encoding / decoding.
 * Use this wrapper instead of methods directly to assure compatibility with both browser and Node.
 * TODO: Consider switching to native methods: separate for broser and Node.
 */
export class Base64 {

  /**
   * Encodes a string with Base64 encoding.
   * @param text The text that should be encoded.
   * @returns The base64 encoded string.
   */
  public static encode(text: string): string {
    return Base64lib.encode(text);
  }

  /**
   * Encodes a string with Base64 URL encoding.
   * @param text The text that should be encoded.
   * @returns The base64 URL encoded string.
   */
  public static encodeUrl(text: string): string {
    return Base64lib.encodeURL(text);
  }

  /**
   * Decodes a Base64 encoded string. Wrapper around js-base64 library.
   * @param text The Base64 encoded string to be decoded
   * @returns The decoded string.
   */
  public static decode(text: string): string {
    return Base64lib.decode(text);
  }

  /**
   * Creates a Base64-encoded ASCII string from a binary string (i.e., a string in which each character in the string is treated as a byte of binary data).
   * Corresponds to browser btoa() method.
   * @param text The binary array that should be encoded.
   * @returns The base64 encoded string.
   */
  public static btoa(text: string): string {
    return Base64lib.btoa(text);
  }

  /**
   * Decodes a Base64 encoded string as binary bytes. The same as browser atob.
   * @param text The Base64 encoded string to be decoded
   * @returns The decoded bytes array.
   */
  public static atob(text: string): string {
    return Base64lib.atob(text);
  }

  /**
   * Creates a Base64-encoded ASCII string from a Uint8Array (e.g. `new Uint8Array()` of `ArrayBuffer`).
   * @param array The ASCII int array that should be encoded.
   * @returns The base64 encoded string.
   */
  public static fromUint8Array(array: Uint8Array): string {
    return Base64lib.fromUint8Array(array);
  }

  /**
   * Decodes a Base64 encoded string as an ASCII array.
   * @param text The Base64 encoded string to be decoded
   * @returns The result as an ASCII array.
   */
  public static toUint8Array(text: string): Uint8Array {
    return Base64lib.toUint8Array(text);
  }

}